import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../services/auth/auth.service';
import {StorageMap} from '@ngx-pwa/local-storage';
import { lang } from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private storage: StorageMap,
    private authSrv: AuthService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (resolve) => {
      // SSO inbound: let app.component handle token storage before guard redirects
      if (route.queryParams['ssoToken']) {
        resolve(true);
        return;
      }

      const isLogged = await this.authSrv.isReallyLogged();


      if (!isLogged) {
        const language = await this.storage.get('language').toPromise();
        await this.router.navigate(['/', language]);
        resolve(false);
      } else {

        const user = await this.authSrv.getUser();

        // get body element
        const body = document.getElementsByTagName('body')[0];

        // check and set dys font
        const enabledDysFont: boolean = user.isDys === true;
        if (enabledDysFont) {
          body.classList.add('dys');
        } else {
          body.classList.remove('dys');
        }

        // check and set big font
        const enabledBigFont: boolean = user.isBigFont === true;
        if (enabledBigFont) {
          body.classList.add('big-font');
        } else {
          body.classList.remove('big-font');
        }

        resolve(true);
      }
    });
  }

}
